import Column from '@app/components/layout/Column'
import { TextField } from '@app/components/core/form/fields/TextField'
import { FormField } from '@app/components/core/form/FormField'
import { TextInput } from '@app/components/core/input/text/TextInput'
import { useTranslations } from '@i18n/useLanguage'
import { type ReactNode, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { normalizePhoneInput } from '@app/util/helpers'
import type { ContactDetailsFormValues } from '@app/pages/dashboard/initiative/shared/validation/initiativeValidation'

const labelStyle = {
  color: 'var(--brand-secondary)',
  fontWeight: 500,
} as const

export const ContactDetailsFormInitialSync = ({
  initial,
}: {
  initial: ContactDetailsFormValues
}): ReactNode => {
  const { reset, trigger } = useFormContext<ContactDetailsFormValues>()
  useEffect(() => {
    reset(initial)
    void trigger()
  }, [initial, reset, trigger])
  return null
}

export const ContactDetailsFormFields = (): ReactNode => {
  const creation = useTranslations().app.dashboard.initiative.creation

  return (
    <Column gap="1rem" alignItems="stretch">
      <TextField<ContactDetailsFormValues>
        name="contactFirstName"
        label={creation.contactPersonFirstName}
        labelStyle={labelStyle}
      />
      <TextField<ContactDetailsFormValues>
        name="contactLastName"
        label={creation.contactPersonLastName}
        labelStyle={labelStyle}
      />
      <TextField<ContactDetailsFormValues>
        name="contactEmail"
        label={creation.contactPersonEmailAdress}
        labelStyle={labelStyle}
      />
      <FormField<ContactDetailsFormValues>
        name="contactPhoneNumber"
        render={({ value, onChange, onBlur, errorMessage }) => (
          <TextInput
            label={creation.contactPersonPhoneNumber}
            labelStyle={labelStyle}
            text={(value as string) ?? ''}
            setText={(v) => onChange(normalizePhoneInput(v))}
            onBlur={onBlur}
            errorMessage={errorMessage}
            inputType="tel"
            inputMode="tel"
            maxLength={16}
          />
        )}
      />
    </Column>
  )
}
